module.exports = __webpack_public_path__ + "static/media/Galeri_7.5aa12d60.jpg";